<template>
    <div class="mobile-page">
        <div class="title-box"
             :style="[
            {'textAlign':configData.textPosition.list[configData.textPosition.type].style},
            {'fontStyle': configData.textStyle.list[configData.textStyle.type].style !='bold' ? configData.textStyle.list[configData.textStyle.type].style:''},
            {'fontWeight':configData.textStyle.list[configData.textStyle.type].style  =='bold' ? configData.textStyle.list[configData.textStyle.type].style:''},
            {'fontSize':configData.fontSize.val+'px'},
            {'marginTop':configData.mbConfig.val+'px'},
            {'background':configData.bgColor.color[0].item},
            {'margin':'0 '+ configData.prConfig.val + 'px'},
            {'color':configData.titleColor.color[0].item}
         ]">
            {{configData.listConfig.list[0].info[0].value}}
        </div>
    </div>
</template>

<script>
    export default {
        name: "htitle",
        sort: 200,
        cname: '标题',
        type: 2, // 0 基础组件 1 营销组件 2工具组件
        icon: 'iconbiaoti1',
        props: {
            configData: {
                type: Object,
                default: {}
            }
        },
        mounted() {

        },
        data() {
            return {
                defaultConfig: {
                    name: "htitle",
                    cname: '标题',
                    tabs: [
                        {
                            title: '内容设置'
                        },
                        {
                            title: '样式设置'
                        }
                    ],
                    styles: {
                        listConfig: {
                            title: '',
                            tab: 0,
                            name: 'list',
                            maxList: 1,
                            list: [
                                {
                                    info: [
                                        {
                                            title: '公告',
                                            value: '',
                                            tips: '',
                                        },
                                        {
                                            title: '链接',
                                            value: '',
                                            tips: '请选择链接',
                                        }
                                    ]
                                }
                            ]
                        },
                        bgColor: {
                            title: '背景颜色',
                            tab: 1,
                            name: 'colors',
                            default: [{
                                item: '#f5f5f5'
                            }],
                            color: [
                                {
                                    item: '#f5f5f5'
                                }
                            ]
                        },
                        titleColor: {
                            title: '文字颜色',
                            tab: 1,
                            name: 'colors',
                            default: [
                                {
                                    item: '#333'
                                }
                            ],
                            color: [
                                {
                                    item: '#333'
                                }
                            ]
                        },
                        prConfig: {
                            title: '背景边距',
                            tab: 1,
                            name: 'slider',
                            val: 10,
                            min: 0
                        },
                        textPosition: {
                            tab: 1,
                            title: '文本位置',
                            name: 'radio',
                            type: 0,
                            list: [
                                {
                                    val: '居左',
                                    style: 'left',
                                    icon: 'icondoc_left'
                                },
                                {
                                    val: '居中',
                                    style: 'center',
                                    icon: 'icondoc_center'
                                },
                                {
                                    val: '居右',
                                    style: 'right',
                                    icon: 'icondoc_right'
                                }
                            ]
                        },
                        textStyle: {
                            tab: 1,
                            title: '文本样式',
                            name: 'radio',
                            type: 0,
                            list: [
                                {
                                    val: '正常',
                                    style: 'normal',
                                    icon: 'icondoc_general'
                                },
                                {
                                    val: '斜体',
                                    style: 'italic',
                                    icon: 'icondoc_skew'
                                },
                                {
                                    val: '加粗',
                                    style: 'bold',
                                    icon: 'icondoc_bold'
                                }
                            ]
                        },
                        fontSize: {
                            title: '文本大小',
                            tab: 1,
                            name: 'slider',
                            val: 12,
                            min: 12
                        },
                        // 页面间距
                        mbConfig: {
                            title: '页面间距',
                            tab: 1,
                            name: 'slider',
                            val: 0,
                            min: 0
                        },
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .box {
        height: 20px;
        background: #F5F5F5;
    }
</style>
